<template>
  <Dialog :common-dialog="dialog" :dialog-width="dialogWidth">
    <template v-slot:title>
      <v-layout class="px-4">
        <v-flex> Select a Supplier </v-flex>
        <v-flex class="text-right">
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button"
            depressed
            icon
            :disabled="loading"
            v-on:click="$emit('close', true)"
            color="red white--text"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <div class="px-4 w-100">
        <label for="cupplier-search" class="font-weight-600"
          >Which cupplier would you like to select this for?</label
        >
        <div class="d-flex mb-2">
          <v-text-field
            id="supplier-search"
            v-model="search"
            class="line-item-header-text px-0 v-slot-m-none"
            placeholder="Search Suppliers..."
            dense
            filled
            solo
            flat
            color="cyan"
            :loading="loading"
            :disabled="loading"
            style="max-width: 400px"
            v-on:keyup.enter="getSuppliers()"
          />
          <v-btn
            v-on:click="getSuppliers()"
            :loading="loading"
            :disabled="loading"
            style="height: 32px !important"
            class="custom-bold-button ml-2"
            depressed
            color="cyan white--text"
            >Search</v-btn
          >
        </div>
        <div
          class="custom-border-top"
          style="max-height: calc(100vh - 300px); overflow-y: scroll"
        >
          <div v-if="list.length">
            <div
              v-for="(row, index) in list"
              :key="`supplier-list-key-${index}`"
              class="cursor-pointer hover-grey d-flex align-center custom-border-bottom py-3 px-3"
              v-on:click="selectSupplier(row)"
            >
              <div style="width: 80%">
                <p class="m-0 font-weight-500 font-size-16">
                  <Barcode :barcode="row.barcode" />
                </p>
                <p class="m-0 font-weight-500 font-size-16">
                  <v-icon class="chip-custom-blue mr-2" small
                    >mdi-bag-checked</v-icon
                  ><template v-if="row.company_name">
                    {{ row.company_name }}
                  </template>
                  <em v-else class="text-muted"> no company </em>
                </p>
                <p class="m-0 font-weight-500 font-size-16">
                  <v-icon class="chip-custom-blue mr-2" small
                    >mdi-account</v-icon
                  >{{ row?.default_person?.display_name }}
                </p>
                <p class="m-0 font-weight-500 font-size-16">
                  <v-icon class="chip-custom-blue mr-2" small
                    >mdi-map-marker-outline</v-icon
                  >{{ row?.single_billing?.street_1 }}
                  {{ row?.single_billing?.unit_no }}
                  {{ row?.single_billing?.street_2 }}
                  {{ row?.single_billing?.zip_code }}
                </p>
              </div>
              <div style="width: 20%">
                <p class="m-0 font-weight-500 font-size-16">
                  {{ row.persons_count }} Contact Person
                </p>
              </div>
            </div>
          </div>
          <div
            v-else
            class="d-flex justify-center align-center py-3 font-weight-500"
          >
            <img
              width="40px"
              :src="$assetURL('media/error/empty.png')"
              class="row-not-found-image mr-2"
            />
            Uhh... There are no supplier at the moment.
          </div>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import Barcode from "@/view/pages/partials/Barcode.vue";
import { QUERY } from "@/core/services/store/request.module";
import { SET_SUPPLIER} from "@/core/services/store/customer.module";
import ObjectPath from "object-path";

export default {
  name: "select-supplier",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      search: null,
      list: [],
    };
  },
  watch: {
    dialog(param) {
      this.search = null;
      if (param) {
        this.getSuppliers();
      }
    },
  },
  components: {
    Dialog,
    Barcode,
  },
  methods: {
    selectSupplier(row) {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      this.$store
        .dispatch(SET_SUPPLIER, row)
        .then(() => {
          this.$emit("close", true);
          this.search = null;
          this.list = [];
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSuppliers() {
      this.loading = true;
      this.list = [];
      this.$store
        .dispatch(QUERY, {
          url: "supplier-listing",
          data: { search: this.search },
        })
        .then((response) => {
          this.list = ObjectPath.get(response, "data", []);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
